export type TypeCaches<TValue = unknown> = Record<string, TValue>;

// ----------------------------------------------------------------------------

class CacheManager<TValue = unknown> {
    #caches: TypeCaches<TValue> = {};

    has(key: string): boolean {
        return Object.hasOwn(this.#caches, key);
    }

    add(key: string, value: TValue): void {
        this.#caches[key] = value;
    }

    get(key: string): TValue | undefined {
        return this.#caches[key];
    }

    remove(key: string): void {
        delete this.#caches[key];
    }

    purge(): void {
        this.#caches = {};
    }
}

// ----------------------------------------------------------------------------

export default CacheManager;
